import { CTA } from '@volkswagen-onehub/components-core';
import { Add } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { useOfertaCard } from '../../context/ofertas-card-context';
import { useOfertasTracker } from '../../helpers/use-ofertas-tracker';
import { CarlineWithOfertas } from '../../services/ofertas-service/models/ofertas';

export const OpenLayerCTA = ({
	buttonSize,
	carline,
}: {
	buttonSize: 'small' | 'large';
	carline: CarlineWithOfertas;
}): React.ReactElement => {
	const { setIsLayerVisible, selectedOferta, setSelectedOferta } = useOfertaCard();
	const { trackOfertasButtonClick } = useOfertasTracker();

	const handleOpenLayerOnClick = () => {
		if (setSelectedOferta && selectedOferta) {
			setSelectedOferta(selectedOferta);
			trackOfertasButtonClick('Open Oferta Layer', selectedOferta, carline);
		}

		setIsLayerVisible(true);
	};

	return (
		<CTA
			tag="button"
			emphasis="primary"
			onClick={handleOpenLayerOnClick}
			ariaL-label="Abrir oferta layer"
			size={buttonSize}
			icon={<Add variant={buttonSize === 'large' ? 'default' : 'small'} aria-hidden />}
		/>
	);
};
